<template>
  <EditorIsland
    role="contentinfo"
    class="mt-auto grid w-full grid-cols-1 place-items-center gap-4 px-4 py-2 text-gray-600 sm:grid-cols-2 md:mx-auto md:grid-cols-4 md:gap-16 md:px-16 md:py-3"
  >
    <Button label="Testzugang" href="mailto:didab@gdw-nord.de?subject=Testzugang%20didab-BildungsEditor">
      Testzugang
    </Button>
    <Button label="www.didab.info" href="https://www.didab.info/bildungseditor"> www.didab.info </Button>
    <Button label="Impressum" to="/impressum"> Impressum </Button>
    <Button label="Datenschutz" href="https://www.gdw-nord.de/datenschutz/"> Datenschutz </Button>
  </EditorIsland>
</template>

<script setup lang="ts">
defineProps<{
  breadcrumbs?: { label?: string; to?: string }[];
}>();
</script>
